import getOptionValue from 'src/utils/userPreferences/getOptionValue';
export default getOptionValue;
